import noop from '@gaia/util/noop/action'
import index from 'app/request/action/index'
import showAttachments from 'app/_shared/action/showAttachments'
import created from 'app/request/action/created'
import create from 'app/request/action/create'
import bulk from 'app/request/action/bulk'
import detail from 'app/request/action/detail'
import description from 'app/request/action/detail/description'
import messageOptions from 'app/request/action/messageOptions'
import location from 'app/request/action/location'
import submitFavorite from 'app/_shared/action/favorite/submit'
import successFavorite from 'app/_shared/action/favorite/success'

export default {
  index,
  create,
  location,
  bulk,
  created,
  detail,
  description,
  attachments: noop,
  messageOptions,
  reopenRequest: noop,
  showAttachments,

  submitFavorite,
  successFavorite,
}
